module.exports = __webpack_public_path__ + "img/loads-5.9b6bf688.jpeg";